import { NavLink } from "react-router-dom";

import css from "./MobileMenuHome.module.css";

export default function MobileMenuHome({ isOpen, onClose }) {
  return (
    <div className={` ${css["modal-overlay"]} ${isOpen ? css["is-open"] : ""}`}>
      <div className={css.modal}>
        <button
          className={css["close-button"]}
          type="button"
          aria-expanded={isOpen}
          aria-controls="mobile-menu"
          aria-label="close menu"
          onClick={onClose}
        >
          <svg className={`icon ${css["mobile-menu-btn-icon"]}`}>
            <use href="/img/icons.svg#icon-close-button"></use>
          </svg>
        </button>
        <ul className={css["mobile-menu"]}>
          <li>
            <NavLink
              to="/"
              className={`nav-section ${css.mobile}`}
              onClick={onClose}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/portfolio"
              className={`nav-section ${css.mobile}`}
              onClick={onClose}
            >
              Portfolio
            </NavLink>
          </li>
          {/* <li>
            <NavLink
              to="/blog"
              className={`nav-section ${css.mobile}`}
              onClick={onClose}
            >
              Blog
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className={`nav-section ${css.mobile}`}
              onClick={onClose}
            >
              Contact
            </NavLink>
          </li> */}
        </ul>
        <ul className={css["mobile-links"]}>
          <li>
            <a
              href="https://github.com/Olha-Fursova"
              target="_blank"
              className="icon-link"
            >
              <svg className={`${css["mobile-icon"]} icon-nav`}>
                <use href="/img/icons.svg#icon-github"></use>
              </svg>
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/olha-fursova-6727b7265/"
              target="_blank"
              className="icon-link"
            >
              <svg className={`${css["mobile-icon"]} icon-nav`}>
                <use href="/img/icons.svg#icon-linkedin"></use>
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
